import React from "react";
import { withTranslation } from "react-i18next";
import "react-calendar/dist/Calendar.css";

import { connect } from "react-redux";

import { MainHeader, MainFooter } from "../CommonComponents";
import moment from "moment";
import RingLoader from "react-spinners/ClipLoader";
import {
  logoutUser,
  setHelpList,
  showModal,
  hideModal,
} from "../../common/actions/userAccount";
import GLOBAL_CONST from "../../helper/AppConstants";
import { Nokids } from "../Dashboard";

import {
  getStudentsList,
  getSchoolDetails,
  schoolAndKidsFetchDone,
  getOtherChildrenDetails,
  otherChildrenFetchDone,
  otherChildrenListClear,
  getBackToSchoolInformation,
} from "../../common/actions/students";

import {
  getIsTokenValid,
  getIsTokenValidClear,
} from "../../common/actions/userAccount";

import "./styles/style.css";
import MyKidView from "./MyKidView";
import OtherKidView from "./OtherKidView";
import { createLoadingSelector } from "../../common/reducers/selectors";
// import { requestForToken,onMessageListener } from '../../init-fcm'
// import addNotification from "react-push-notification";

const loadingSelector = createLoadingSelector([
  "get_students",
  "get_other_children",
  "get_school_info",
  "get_token_valid",
  "get_back_school"
]);
const loadingSelector2 = createLoadingSelector(["get_back_school"]);
class ChildManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: new Date(),
      OtherSchoolStudentList: [],
      YourSchoolStudentList: [],
      noKidsTitle: "",
      noKidsDetail: "",
      needBackToSchool: false,
      isBackToSchoolPrompted: false,
    };
  }

  async componentDidMount() {
    const { isTermsAccepted } = this.props;
    this.checkTokenValid();
    this.dosetHelpList();

    if (!isTermsAccepted) {
      //   this.props.history.replace("/termsConditions", {
      //     callback: () => {
      //       console.log("TermsAccept callback");
      //       this.processBackToSchool(this.state.needBackToSchool);
      //     },
      //   });
      this.props.history.replace("/termsConditions");
    } else {
      this.processBackToSchool(this.state.needBackToSchool);
    }
  }
  processBackToSchool = (needBackToSchool) => {
    console.log("processBackToSchool needBackToSchool " + needBackToSchool);
    if (needBackToSchool) {
      const { nextAskMeLater } = this.props;
      if (
        nextAskMeLater !== null &&
        nextAskMeLater !== undefined &&
        moment().isBefore(nextAskMeLater, "date")
      ) {
        console.log("processBackToSchool askMeLater " + nextAskMeLater);
        return;
      }
      console.log("processBackToSchool calling getBackToSchoolInfo");
      this.getBackToSchoolInfo();
    }
  };
  getBackToSchoolInfo = () => {
    const { isBackToSchoolPrompted } = this.state;

    // const isFocused = this.props.navigation.isFocused();
    // if(Platform.OS === 'ios' && !isFocused) return;
    // if(Platform.OS ==='android' && isBackToSchoolPrompted && !isFocused) return;

    const { doGetbacktoschoolInfo, studentsList } = this.props;
    const students = studentsList && studentsList.TodaysStudents;
    const studentRecords = [...students];
    const kidsList = studentRecords.filter((item)=> !item.IsDelegation)
        
    doGetbacktoschoolInfo({
      callback: (getBackSchoolInfoData) => {
        if (getBackSchoolInfoData) {
          if (kidsList.length > 1) {
            this.openBackToSchoolKidsModal();
          } else if (kidsList.length === 1) {
            this.props.doShowModal({
              modalScreenName: "backToSchool",
              modalClassName: "backto-school-modal",
              params: {
                studentData: kidsList[0],
                backToSchoolInfoData: getBackSchoolInfoData[0],
                isSingleKid: true,
                doCallbackRefresh: this.doRefreshListing,
              },
            });
          }
          this.setState({ isBackToSchoolPrompted: true });
        }
      },
    });
  };

  openBackToSchoolKidsModal = () => {
    this.props.doShowModal({
      modalScreenName: "backToSchoolKidList",
      modalClassName: "backto-school-modal",
    });
  };

  setupPush() {
    // requestForToken()
    // onMessageListener()
    // .then((payload) => {
    //   //setNotification({title: payload?.notification?.title, body: payload?.notification?.body});
    //   console.log(JSON.stringify(payload))
    //   alert(JSON.stringify(payload))
    //   addNotification({
    //     title: 'Pikmykid',
    //     subtitle: payload.notification.title,
    //     message: payload.notification.body,
    //     theme: 'darkblue',
    //     native: true
    //   })
    // })
    // .catch((err) => console.log('failed: ', err));
    // navigator.serviceWorker.addEventListener("message",(message) =>{
    //   console.log(JSON.stringify(message))
    // });
  }

  dosetHelpList = () => {
    this.props.dosetHelpList({
      stackType: "ChildManagement",
      screen: GLOBAL_CONST.SCREEN_NAMES.MANAGE_CHILDREN_TAB,
      title: this.props.t("manageChildrenScr-manageChildren"),
    });
  };

  componentWillUnmount() {
    this.setState({ OtherSchoolStudentList: [], YourSchoolStudentList: [] });
  }

  checkTokenValid = () => {
    const { doGetIsTokenValid } = this.props;
    doGetIsTokenValid();
  };

  doRefreshListing = () => {
    this.checkTokenValid();
    this.dosetHelpList();
  };

  initialLoad = () => {
    this.getSchool(this.getStudents);
    this.fetchOtherChildrenList();
  };

  getStudents = () => {
    const { doGetStudentsList } = this.props;
    let currenDate = moment().format("MM-DD-YYYY");
    doGetStudentsList({ currenDate });
  };

  getSchool = (callback) => {
    const { doGetSchoolDetails } = this.props;
    doGetSchoolDetails().then(() => {
      callback();
    });
  };

  fetchOtherChildrenList = () => {
    const { doGetOtherChildrenList } = this.props;
    doGetOtherChildrenList();
  };

  buildYourChildrenList = () => {
    const { studentsList, schoolInfo, isTermsAccepted } = this.props;
    const schools = schoolInfo;
    const students = studentsList && studentsList.TodaysStudents;
    const { yourChildrenRefreshing } = this.state;
    let needBackToSchool = false;

    if (!schools || !students) return;

    const kids = [];
    for (let i = 0; i < schools.length; i++) {
      let schoolstudents = [];
      const LastDayOfSchool = new Date(schools[i].Dates.LastDayOfSchool);
      const isLastDayOfSchoolPast = moment(LastDayOfSchool).isBefore(moment());
      for (let j = 0; j < students.length; j++) {
        if (
          schools[i].SchoolID === students[j].SchoolID &&
          students[j].IsDelegation === false
        ) {
          students[j].isLastDayOfSchoolPast = isLastDayOfSchoolPast;
          schoolstudents.push(students[j]);
        }
        if (students[j].AskForBackToSchool) needBackToSchool = true;
      }
      schoolstudents = schoolstudents.sort((a, b) =>
        a.Firstname.toLowerCase() > b.Firstname.toLowerCase()
          ? 1
          : b.Firstname.toLowerCase() > a.Firstname.toLowerCase()
          ? -1
          : 0
      );

      if (schoolstudents.length > 0) {
        let sectiondata = {
          schoolId: schools[i].SchoolID,
          address: schools[i].Address,
          schoolzip: schools[i].State + " " + schools[i].Zip,
          title: schools[i].Name,
          schoolLat: schools[i].Coordinates.latitude,
          schoolLong: schools[i].Coordinates.longitude,
          AnnounceDistance: schools[i].AnnounceDistance,
          school: schools[i],
          data: schoolstudents,
          isLastDayOfSchoolPast,
        };
        kids.push(sectiondata);
      }
    }
    const sortedSchoolStudentList = kids.sort((a, b) =>
      a.title.toLowerCase() > b.title.toLowerCase()
        ? 1
        : b.title.toLowerCase() > a.title.toLowerCase()
        ? -1
        : 0
    );
    this.setState({
      YourSchoolStudentList: sortedSchoolStudentList,
      needBackToSchool,
    });

    if (isTermsAccepted) {
      this.processBackToSchool(needBackToSchool);
    }
  };

  getYourChildrenView = () => {
    const { YourSchoolStudentList } = this.state;
    const { isFetching } = this.props;
    const childViews = [];

    for (var i = 0; i < YourSchoolStudentList.length; i++) {
      const { data, school } = YourSchoolStudentList[i];
      for (var k = 0; k < data.length; k++) {
        childViews.push(this.renderMyChild(data[k], school));
      }
    }
    // if (isFetching) {
    //   return (
    //     <div className="loaderHolder mt-60">
    //       <RingLoader color="#3fa9f5" loading={isFetching} size={60} />
    //     </div>
    //   );
    // } else {
    //   return childViews;
    // }
    return childViews;
  };

  renderMyChild = (child, school) => {
    //console.log("child.StudentID ", child.StudentID)
    return (
      <MyKidView
        key={"mykid-" + child.StudentID}
        child={child}
        school={school}
      ></MyKidView>
    );
  };

  buildOtherChildrenList = () => {
    const { otherChildrens, schoolInfo } = this.props;
    const schools = schoolInfo;
    const children = otherChildrens;
    if (!schools || !children) return;

    const kids = [];
    for (let i = 0; i < schools.length; i++) {
      let schoolstudents = [];
      for (let j = 0; j < children.length; j++) {
        if (schools[i].SchoolID === children[j].SchoolID) {
          schoolstudents.push(children[j]);
        }
      }

      schoolstudents = schoolstudents.sort((a, b) =>
        a.StudentName.FirstName.toLowerCase() >
        b.StudentName.FirstName.toLowerCase()
          ? 1
          : b.StudentName.FirstName.toLowerCase() >
            a.StudentName.FirstName.toLowerCase()
          ? -1
          : 0
      );

      if (schoolstudents.length > 0) {
        let sectiondata = {
          schoolId: schools[i].SchoolID,
          address: schools[i].Address,
          schoolzip: schools[i].State + " " + schools[i].Zip,
          title: schools[i].Name,
          schoolLat: schools[i].Coordinates.latitude,
          schoolLong: schools[i].Coordinates.longitude,
          AnnounceDistance: schools[i].AnnounceDistance,
          data: schoolstudents,
        };
        kids.push(sectiondata);
      }
    }

    const sortedSchoolStudentList = kids.sort((a, b) =>
      a.title.toLowerCase() > b.title.toLowerCase()
        ? 1
        : b.title.toLowerCase() > a.title.toLowerCase()
        ? -1
        : 0
    );
    this.setState({ OtherSchoolStudentList: sortedSchoolStudentList });
  };

  getOtherChildrenView = () => {
    const { OtherSchoolStudentList } = this.state;
    const { isFetching } = this.props;
    const childViews = [];
    for (var i = 0; i < OtherSchoolStudentList.length; i++) {
      const { data, title } = OtherSchoolStudentList[i];
      for (var k = 0; k < data.length; k++) {
        childViews.push(this.renderOtherChild(data[k], title));
      }
    }

    return childViews;
  };

  renderOtherChild = (child, title) => {
    // console.log("child.StudentID ", child.StudentID)
    return (
      <OtherKidView
        key={"otherkid-" + child.StudentID}
        child={child}
        title={title}
      ></OtherKidView>
    );
  };

  showEmpty = () => {
    let noKidsTitle = this.props.t("dashBoardScr-noKidsTitle");
    let noKidsDetail = this.props.t("dashBoardScr-noKidsDetail");
    let noKidsData = { noKidsTitle, noKidsDetail };

    return <Nokids {...noKidsData} />;
  };

  componentDidUpdate() {
    const { yourChildrenRefreshing, otherChildrenRefreshing } = this.state;

    const {
      isFetching,
      isTokenValidResponse,
      doGetIsTokenValidClear,
      doLogoutUser,
      fetchStudentListDone,
      fetchSchoolInfoDone,
      fetchOtherChildrenDone,
      doSchoolAndKidsFetchDone,
      doOtherChildrenFetchDone,
    } = this.props;

    if (isTokenValidResponse) {
      if (isTokenValidResponse.Success === false) {
        doLogoutUser();
        this.props.history.push("/");
      } else {
        this.initialLoad();
      }
      doGetIsTokenValidClear();
    }

    if (yourChildrenRefreshing === true) {
      if (isFetching === false)
        this.setState({ yourChildrenRefreshing: false, isPullRefresh: false });
    }
    if (otherChildrenRefreshing === true) {
      if (isFetching === false)
        this.setState({ otherChildrenRefreshing: false, isPullRefresh: false });
    }

    if (fetchStudentListDone === true && fetchSchoolInfoDone === true) {
      this.buildYourChildrenList();
      doSchoolAndKidsFetchDone();
    }
    if (fetchOtherChildrenDone === true) {
      this.buildOtherChildrenList();
      doOtherChildrenFetchDone();
    }
  }

  showError = () => {
    const { tokenError, schoolFetchError, studentFetchError } = this.props;
    const msg =
      (tokenError && tokenError.message) ||
      (schoolFetchError && schoolFetchError.message) ||
      (studentFetchError && studentFetchError.message);
    return <div className="alert alert-warning">{msg}</div>;
  };

  ListEmptyComponent = () => {
    const { otherChildrenRefreshing } = this.state;
    const { isFetching, isTokenValidResponse, userLoginInfo } = this.props;

    if (
      isFetching === false &&
      isTokenValidResponse === null &&
      !otherChildrenRefreshing
    ) {
      return (
        <section className="pmk-child-schedule emptylistOtherkids">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12 text-center">
                <p>{this.props.t("OtherChildrenNoRecord1")}</p>
                <p>
                  {this.props.t("OtherChildrenNoRecord2")}
                  <span className="blue-text">
                    {userLoginInfo
                      ? userLoginInfo.CountryCode + userLoginInfo.mobile
                      : ""}
                  </span>
                </p>
                <p>{this.props.t("OtherChildrenNoRecord3")}</p>
              </div>
            </div>
          </div>
        </section>
      );
    } else {
      return null;
    }
  };

  openBarCodeScanner = () => {
    this.props.doShowModal({
      modalScreenName: "scanBarCode",
      modalClassName: "barCodeScannerModal",
      params: {
        doCallbackRefresh: this.doRefreshListing,
      },
    });
  };

  render() {
    const { isFetching, displayAds } = this.props;
    const { YourSchoolStudentList, OtherSchoolStudentList } = this.state;
    return (
      <main className="pmk-body graySubtle-bg">
        <MainHeader />

        <section className="pmk-welcome-sect">
          <div className="container-fluid">
            <div className="row flex-middle">
              <div className="col-xs-12 col-sm-8">
                <div className="title-sect">
                  <h1 className="title-style2">
                    {this.props.t("manageChildrenScr-manageChildren")}
                  </h1>
                  <p className="welcome-text helptext">
                    {this.props.t("manageChildrenScr-manageChildrenDelegate")}
                  </p>
                </div>
              </div>
              <div className="col-xs-12 col-sm-4 text-right">
                <div className="date-text">
                  {moment().format("MMM DD, YYYY")}
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="your-other-children-sect">
          <div className="container-fluid">
            <div className="manageChildrenTabs">
              <ul className="nav nav-tabs nav-tabs-style1" role="tablist">
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link active"
                    id="your-children-tab"
                    data-toggle="tab"
                    href="#your-children-cont"
                    role="tab"
                    aria-controls="yourchildren-tab"
                    aria-selected="true"
                  >
                    {this.props.t("selectCheckScr-children")}
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link"
                    id="other-children-tab"
                    data-toggle="tab"
                    href="#other-children-cont"
                    role="tab"
                    aria-controls="other-children"
                    aria-selected="false"
                  >
                    {this.props.t("manageChildrenScr-otherChildren")}
                  </a>
                </li>
              </ul>
              <div className="tab-content">
                <div
                  className="tab-pane fade show active"
                  id="your-children-cont"
                  role="tabpanel"
                  aria-labelledby="yourchildren-tab"
                >
                  {isFetching ? (
                    <div className="loaderHolder mt-60">
                      <RingLoader
                        color="#3fa9f5"
                        loading={isFetching}
                        size={60}
                      />
                    </div>
                  ) : !isFetching && YourSchoolStudentList.length === 0 ? (
                    this.showEmpty()
                  ) : (
                    <div className="table-holder">
                      <table className="table table-borderless table-style1 your-children-tbl">
                        <thead>
                          <tr>
                            <th width="30%" scope="col">
                              {this.props.t("manageChildrenScr-childLabel")}
                            </th>
                            <th width="20%" scope="col" className="hidden-xs">
                              {this.props.t(
                                "manageChildrenScr-dismissalModeLabel"
                              )}
                            </th>
                            <th width="20%" scope="col">
                              {this.props.t(
                                "manageChildrenScr-dismissalStatusLabel"
                              )}
                            </th>
                            <th width="30%" scope="col" className="hidden-xs">
                              {this.props.t("School")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>{this.getYourChildrenView()}</tbody>
                      </table>
                    </div>
                  )}
                </div>
                <div
                  className="tab-pane fade"
                  id="other-children-cont"
                  role="tabpanel"
                  aria-labelledby="otherchildren-tab"
                >
                  {!isFetching && OtherSchoolStudentList.length === 0 ? (
                    this.ListEmptyComponent()
                  ) : (
                    <table className="table table-borderless table-style1 your-children-tbl">
                      <thead>
                        <tr>
                          <th width="30%" scope="col">
                            {this.props.t("manageChildrenScr-childLabel")}
                          </th>
                          <th width="20%" scope="col">
                            {this.props.t("manageChildrenScr-ParentsName")}
                          </th>
                          <th width="20%" scope="col" className="hidden-xs">
                            {this.props.t("otherChildrenScr-nextPickupLabel")}
                          </th>
                          <th width="30%" scope="col" className="hidden-xs">
                            {this.props.t("School")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>{this.getOtherChildrenView()}</tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
        <div
          className="qrcode-btn"
          style={{
            bottom: displayAds === true ? "72px" : "5px",
          }}
          onClick={() => {
            this.openBarCodeScanner();
          }}
        >
          <i className="fas fa-qrcode"></i>
        </div>
        <MainFooter />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    otherChildrens: state.student.otherChildrens,
    studentsList: state.student.studentsList,
    schoolInfo: state.student.schoolInfo,
    fetchStudentListDone: state.student.fetchStudentListDone,
    fetchSchoolInfoDone: state.student.fetchSchoolInfoDone,
    fetchOtherChildrenDone: state.student.fetchOtherChildrenDone,
    isTokenValidResponse: state.userAccount.isTokenValidResponse,
    isFetching: loadingSelector(state),
    error: state.student.error,

    tokenError: state.userAccount.tokenError,
    userLoginInfo: state.userAccount.userLoginInfo,
    schoolFetchError: state.student.schoolFetchError,
    studentFetchError: state.student.studentFetchError,
    otherChildrensFetchError: state.student.otherChildrensFetchError,
    setHelpListData: state.userAccount.setHelpListData,
    displayAds: state.userAccount.displayAds,
    isTermsAccepted: state.userAccount.isTermsAccepted,
    getBackSchoolInfoData: state.student.getBackSchoolInfo,
    nextAskMeLater: state.userAccount.nextAskMeLater,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    doGetOtherChildrenList: () => dispatch(getOtherChildrenDetails()),
    doGetStudentsList: (data) => dispatch(getStudentsList(data)),
    doGetSchoolDetails: () => dispatch(getSchoolDetails()),
    doGetIsTokenValid: (data) => dispatch(getIsTokenValid(data)),
    doGetIsTokenValidClear: () => dispatch(getIsTokenValidClear()),
    doSchoolAndKidsFetchDone: () => dispatch(schoolAndKidsFetchDone()),
    doOtherChildrenListClear: () => dispatch(otherChildrenListClear()),
    doLogoutUser: () => dispatch(logoutUser()),
    doOtherChildrenFetchDone: () => dispatch(otherChildrenFetchDone()),
    doGetbacktoschoolInfo: (data) => dispatch(getBackToSchoolInformation(data)),

    dosetHelpList: (data) => dispatch(setHelpList(data)),
    doShowModal: (data) => dispatch(showModal(data)),
    doHideModal: () => dispatch(hideModal()),
  };
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(ChildManagement)
);
